let form = {
  items: {},
};

const getters = {
  GET_ITEMS(state) {
    return state.items;
  },
};
const mutations = {
  CLEAR(state) {
    state.items = {};
  },
  ADD_ITEM(state, item) {
    state.items[item.name] = item.content;
  },
  SET_VALUE_ITEM(state, item) {
    state.items[item.name]['value'] = item.value;
  },
};

const actions = {
  clear({ commit }) {
    commit('CLEAR');
  },
  addItem({ commit }, item) {
    commit('ADD_ITEM', item);
  },
  setValueItem({ commit }, item) {
    commit('SET_VALUE_ITEM', item);
  },
};

export default {
  namespaced: true,
  state: form,
  getters,
  mutations,
  actions,
};
